export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Disputed columns"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reset"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])}
}